import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  NgZone,
  Output,
  Input,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { CoreService } from "../../services/coreService";
import {
  UntypedFormControl,
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  ValidationErrors,
  UntypedFormArray,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { ValidatorsService } from "../../shared/services/validators.service";
import { MapMarker, GoogleMap, GoogleMapsModule } from "@angular/google-maps";
import { CommonModule } from "@angular/common";
import { MatCardModule } from "@angular/material/card";
import { RouterModule } from "@angular/router";
import { ControlMessageComponent } from "../../shared/components/control-message/control-message.component";
import { MatStepperModule } from "@angular/material/stepper";
import { MatButtonModule } from "@angular/material/button";

declare var toastr: any;

@Component({
  selector: "add-parking-place",
  templateUrl: "./add-parking-place.component.html",
  styleUrls: ["./add-parking-place.component.css"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GoogleMapsModule,
    MatCardModule,
    RouterModule,
    ControlMessageComponent,
    MatButtonModule,
    MatStepperModule,
  ],
})
export class AddParkingPlaceComponent implements OnInit, OnChanges {
  @ViewChild(GoogleMap) map!: GoogleMap;
  beneficiaries;
  private countries: any;
  currentStep = 0;
  parking_types = [
    {
      id: 1,
      label: "Public",
    },
    {
      id: 2,
      label: "Private",
    },
    {
      id: 3,
      label: "Pre-Booking",
    },
    {
      id: 4,
      label: "Semi-Private",
    },
  ];
  public parking_charge_types: any;
  public currency_choices: any;

  public form: UntypedFormGroup;
  public searchControl = new UntypedFormControl();
  public lat = 29.3759;
  public lng = 47.9774;
  public zoom = 15;

  markerOptions: google.maps.MarkerOptions = {
    draggable: true,
  };
  secondStepAttempt = false;
  thirdStepAttempt = false;

  center: google.maps.LatLngLiteral = {
    lat: 25.249062,
    lng: 55.2951105,
  };

  markerPosition: google.maps.LatLngLiteral = {
    lat: 25.249062,
    lng: 55.2951105,
  };

  @ViewChild("logo", { static: true })
  logoRef!: ElementRef;

  @ViewChild("video", { static: true })
  videoRef!: ElementRef;
  @ViewChild("search", { static: true })
  public searchElementRef1!: ElementRef;
  public draggable: boolean;
  private place: any;
  public Address: any;
  public stack: UntypedFormGroup;
  public beneficiary: UntypedFormGroup;
  public gate: UntypedFormGroup;
  public autopay: UntypedFormGroup;

  public camera_groups: UntypedFormGroup;
  public isSubmitted: any = false;
  public view_gate;
  public selected_gate;
  public selected_gate_type;
  public selected_gate_status;
  public view_charge_stack;
  public selected_rate;
  public selected_label_en;
  public selected_label_ar;
  public selected_from_minutes;
  public selected_to_minutes;
  public view_camera_groups;
  public selected_camera_group_id;
  public selected_name;
  public selected_parking_gates;
  public selected_status;
  public view_beneficiaries;
  public selected_beneficiary;
  public selected_amount_type;
  public selected_amount_calc;
  public selected_value;

  public view_autopay;
  public selected_machine_id;
  // public selected_gate_type;
  public selected_autopay_status;

  @Input()
  data: any = null;
  @Input()
  logo: {
    base64;
    filename;
    content_type;
  } = {
    base64: null,
    filename: null,
    content_type: null,
  };

  video: {
    base64;
    filename;
    content_type;
  } = {
    base64: null,
    filename: null,
    content_type: null,
  };
  @Output()
  submit = new EventEmitter<any>();

  constructor(
    private coreService: CoreService,
    private ngZone: NgZone,
    private builder: UntypedFormBuilder,
    private validatorsService: ValidatorsService,
  ) {
    this.form = this.builder.group({
      code: ["", Validators.required],
      title: ["", Validators.required],
      title_ar: [""],
      content_type: [this.logo.content_type],
      filename: [this.logo.filename],
      videoname: [this.video.filename],
      video_content_type: [this.video.content_type],
      video_base64: [this.video.base64],
      base64: [this.logo.base64],
      vg_url: ["", [Validators.required, this.validatorsService.url()]],
      online_payment_link: ["", [this.validatorsService.url()]],
      vg_admin: ["", Validators.required],
      vg_password: ["", Validators.required],

      parking_place_type_id: ["", Validators.required],
      min_wallet_limit: [
        "",
        [Validators.required, Validators.pattern(/^(\d+\.?\d*|\.\d+)$/)],
      ],
      perhour: [
        "",
        [Validators.required, Validators.pattern(/^(\d+\.?\d*|\.\d+)$/)],
      ],
      capacity: ["", [Validators.required, Validators.pattern(/^\d+$/)]],
      area: ["", Validators.required],
      area_ar: [""],
      area_app_label: ["", Validators.required],
      area_app_label_ar: [""],
      city: [""],
      city_ar: [""],
      country: ["", Validators.required],
      country_ar: [""],
      lat: [
        "",
        [Validators.required, Validators.pattern(/^-?(\d+\.?\d*|\.\d+)$/)],
      ],
      lng: [
        "",
        [Validators.required, Validators.pattern(/^-?(\d+\.?\d*|\.\d+)$/)],
      ],
      isActive: [true, Validators.required],
      parking_charge_type: ["", Validators.required],
      currency: ["", Validators.required],
      processing_fee: [
        "",
        [Validators.required, Validators.pattern(/^(\d+\.?\d*|\.\d+)$/)],
      ],
      vat_rate: [
        "",
        [Validators.required, Validators.pattern(/^(\d+\.?\d*|\.\d+)$/)],
      ],
      online_payment_grace_period: [
        "",
        [Validators.pattern(/^(\d+\.?\d*|\.\d+)$/)],
      ],
      charge_stack: this.builder.array([], Validators.required),
      parking_gates: this.builder.array([], Validators.required),

      autopay_machines: this.builder.array([], Validators.required),

      camera_groups: this.builder.array([]),
      parking_beneficiary: this.builder.array([], Validators.required),
    });
    this.form.disable();
    console.log(this.form.valid);
    this.stack = this.createFormGroup("stack");
    this.beneficiary = this.createFormGroup("beneficiary");
    this.gate = this.createFormGroup("gate");
    this.camera_groups = this.createFormGroup("camera_groups");
    this.autopay = this.createFormGroup("autopay");

    this.countries = [];
    this.parking_charge_types = [];
    this.currency_choices = [];
    this.draggable = true;
    this.place = {};
  }

  firstStepEnter() {
    this.form.controls.code.enable();
    this.form.controls.base64.enable();
    this.form.controls.content_type.enable();
    this.form.controls.parking_place_type_id.enable();
    this.form.controls.filename.enable();
    this.form.controls.videoname.enable();
    this.form.controls.video_base64.enable();
    this.form.controls.video_content_type.enable();
    this.form.controls.vg_url.enable();
    this.form.controls.online_payment_link.enable();
    this.form.controls.vg_admin.enable();
    this.form.controls.vg_password.enable();
    this.form.controls.min_wallet_limit.enable();
    this.form.controls.isActive.enable();
    this.form.controls.title.enable();
    this.form.controls.title_ar.enable();
    this.form.controls.perhour.enable();
    this.form.controls.capacity.enable();
    this.form.controls.parking_charge_type.enable();
    this.form.controls.currency.enable();
    this.form.controls.processing_fee.enable();
    this.form.controls.vat_rate.enable();
    this.form.controls.online_payment_grace_period.enable();
  }

  secondStepEnter(isForward: boolean) {
    console.log(this.form.valid);
    this.refreshMap();
    if (isForward) {
      this.searchControl.setValue(this.form.controls.area.value);
      this.form.controls.area.enable();
      this.form.controls.area_ar.enable();
      this.form.controls.area_app_label_ar.enable();
      this.form.controls.area_app_label.enable();
      this.form.controls.city.enable();
      this.form.controls.city_ar.enable();
      this.form.controls.country.enable();
      this.form.controls.country_ar.enable();
      this.form.controls.lat.enable();
      this.form.controls.lng.enable();
    }
  }

  secondStepEnterAttempt() {
    this.secondStepAttempt = true;
    if (
      !(
        this.form.controls.code.valid &&
        this.form.controls.parking_place_type_id.valid &&
        this.form.controls.vg_url.valid &&
        this.form.controls.online_payment_link.valid &&
        this.form.controls.base64.valid &&
        this.form.controls.vg_admin.valid &&
        this.form.controls.vg_password.valid &&
        this.form.controls.min_wallet_limit.valid &&
        this.form.controls.title.valid &&
        this.form.controls.title_ar.valid &&
        this.form.controls.perhour.valid &&
        this.form.controls.capacity.valid &&
        this.form.controls.parking_charge_type.valid &&
        this.form.controls.currency.valid &&
        this.form.controls.processing_fee.valid &&
        this.form.controls.vat_rate.valid &&
        this.form.controls.online_payment_grace_period.valid
      )
    ) {
      toastr.error("", "Form is not valid.", { timeOut: 2000 });
    }
  }

  canEnterSecondStep() {
    return (
      this.form.controls.code.valid &&
      this.form.controls.parking_place_type_id.valid &&
      this.form.controls.vg_url.valid &&
      this.form.controls.online_payment_link.valid &&
      this.form.controls.base64.valid &&
      this.form.controls.vg_admin.valid &&
      this.form.controls.vg_password.valid &&
      this.form.controls.min_wallet_limit.valid &&
      this.form.controls.title.valid &&
      this.form.controls.title_ar.valid &&
      this.form.controls.perhour.valid &&
      this.form.controls.capacity.valid &&
      this.form.controls.parking_charge_type.valid &&
      this.form.controls.currency.valid &&
      this.form.controls.processing_fee.valid &&
      this.form.controls.vat_rate.valid &&
      this.form.controls.online_payment_grace_period.valid
    );
  }

  thirdStepEnter(isForward: boolean) {
    this.secondStepAttempt = false;
    console.log(this.form.valid);
    if (isForward) {
      this.form.controls.charge_stack.enable();
      this.form.controls.parking_gates.enable();
      this.form.controls.autopay_machines.enable();
      this.form.controls.camera_groups.enable();
      this.form.controls.parking_beneficiary.enable();
    }
  }

  thirdStepEnterAttempt() {
    this.thirdStepAttempt = true;
    if (
      !(
        this.form.controls.area.valid &&
        this.form.controls.area_ar.valid &&
        this.form.controls.area_app_label.valid &&
        this.form.controls.area_app_label_ar.valid &&
        this.form.controls.city.valid &&
        this.form.controls.city_ar.valid &&
        this.form.controls.country.valid &&
        this.form.controls.country_ar.valid &&
        this.form.controls.lat.valid &&
        this.form.controls.lng.valid
      )
    ) {
      toastr.error("", "Form is not valid.", { timeOut: 2000 });
    }
  }

  canEnterThirdStep() {
    return (
      this.form.controls.area.valid &&
      this.form.controls.area_ar.valid &&
      this.form.controls.area_app_label.valid &&
      this.form.controls.area_app_label_ar.valid &&
      this.form.controls.city.valid &&
      this.form.controls.city_ar.valid &&
      this.form.controls.country.valid &&
      this.form.controls.country_ar.valid &&
      this.form.controls.lat.valid &&
      this.form.controls.lng.valid
    );
  }

  onFileChange(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.form.patchValue({
          content_type: file.type,
          filename: file.name,
          base64: (reader.result as string).split(",")[1],
        });
      };
    }
  }

  onVideoChange(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.form.patchValue({
          video_content_type: file.name,
          videoname: file,
          video_base64: (reader.result as string).split(",")[1],
        });
      };
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
    if (changes.data) {
      if (this.data != null) {
        let parking_place = this.data.parking_place;
        this.form.patchValue({
          ...parking_place,
          parking_place_type_id: parking_place.parking_place_type.id,
        });
        let charge_stack = <UntypedFormArray>this.form.controls.charge_stack;
        let parking_gates = <UntypedFormArray>this.form.controls.parking_gates;
        let autopay_machines = <UntypedFormArray>(
          this.form.controls.autopay_machines
        );

        let camera_groups = <UntypedFormArray>this.form.controls.camera_groups;
        let parking_beneficiary = <UntypedFormArray>(
          this.form.controls.parking_beneficiary
        );
        let clearFormArray = (formArray: UntypedFormArray) => {
          while (formArray.length !== 0) {
            formArray.removeAt(0);
          }
        };
        clearFormArray(charge_stack);
        clearFormArray(parking_gates);
        clearFormArray(autopay_machines);
        clearFormArray(camera_groups);
        clearFormArray(parking_beneficiary);
        parking_place.charge_stack.forEach((stack) => {
          let temp = this.createFormGroup("stack");
          temp.patchValue(stack);
          charge_stack.push(temp);
        });

        parking_place.parking_gates.forEach((gate) => {
          let temp = this.createFormGroup("gate");
          temp.patchValue(gate);
          parking_gates.push(temp);
        });

        parking_place.autopay_machines.forEach((autopay) => {
          let temp = this.createFormGroup("autopay");
          temp.patchValue(autopay);
          autopay_machines.push(temp);
        });

        this.data.camera_groups.forEach((group) => {
          let temp = this.createFormGroup("camera_groups");
          temp.patchValue(group);
          camera_groups.push(temp);
        });
        parking_place.parking_beneficiary.forEach((beneficiary) => {
          let temp = this.createFormGroup("beneficiary");
          temp.patchValue(beneficiary);
          parking_beneficiary.push(temp);
        });
        const lat = +this.form.controls.lat.value;
        const lng = +this.form.controls.lng.value;

        this.center = { lat, lng };
        this.markerPosition = { lat, lng };
        console.dir(this.form.value);
      }
      console.log(
        `previous value was: ${JSON.stringify(
          changes.data.previousValue,
        )}, current value is: ${JSON.stringify(changes.data.currentValue)}`,
      );
    }
  }

  refreshMap() {
    this.map.googleMap?.setCenter(this.center);
  }

  async ngOnInit() {
    await this.getParkingPlaceRegConfig();
    await this.getBeneficiaries();

    this.searchControl = new UntypedFormControl();

    this.setCurrentPosition();

    await this.initializeAutocomplete();
    this.firstStepEnter();
  }

  private async initializeAutocomplete(): Promise<void> {
    await google.maps.importLibrary("places");

    const autocomplete = new google.maps.places.Autocomplete(
      this.searchElementRef1.nativeElement,
      {
        types: ["address"],
      },
    );

    autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
        const place = autocomplete.getPlace();

        this.place = place;

        if (!place.geometry?.location) {
          return;
        }

        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        this.center = { lat, lng };
        this.markerPosition = { lat, lng };

        this.form.patchValue({
          lat,
          lng,
          area: place.formatted_address,
          area_ar: place.formatted_address,
        });

        const arr = place.formatted_address?.split(", ") ?? [];

        if (arr.length) {
          this.form.patchValue({
            country: arr[arr.length - 1],
            country_ar: arr[arr.length - 1],
          });
        }
      });
    });
  }

  createFormGroup(source) {
    switch (source) {
      case "stack": {
        return this.builder.group({
          id: [null],
          from_min: [null, [Validators.required, Validators.pattern(/^\d+$/)]],
          to_min: [null, [Validators.required, Validators.pattern(/^\d+$/)]],
          rate: [
            null,
            [Validators.required, Validators.pattern(/^(\d+\.?\d*|\.\d+)$/)],
          ],
          label_en: [null],
          label_ar: [null],
          currency: [null],
        });
      }

      case "gate": {
        return this.builder.group({
          id: [null],
          // gate_area: [null],
          gate_no: [null, [Validators.required]],
          gate_type: [null, [Validators.required]],
          status: [null, [Validators.required]],
        });
      }
      case "camera_groups": {
        return this.builder.group({
          id: [null],
          camera_group_id: [null, [Validators.required]],
          name: [null, [Validators.required]],
          parking_gates: [null, [Validators.required]],
          autopay_machines: [null, [Validators.required]],
          status: [null, [Validators.required]],
        });
      }
      case "beneficiary": {
        return this.builder.group({
          id: [null],
          beneficiary: [null, [Validators.required]],
          amount_type: [null, [Validators.required]],
          amount_calc: [null, [Validators.required]],
          value: [
            null,
            [Validators.required, Validators.pattern(/^(\d+\.?\d*|\.\d+)$/)],
          ],
        });
      }
      case "autopay": {
        return this.builder.group({
          id: [null],
          // gate_area: [null],
          machine_id: [null, [Validators.required]],
          // gate_type: [null, [Validators.required]],
          machine_status: [null, [Validators.required]],
        });
      }
    }
  }

  async getBeneficiaries() {
    try {
      this.beneficiaries = await this.coreService
        .GetBeneficiaries()
        .then((response) => response.data);
    } catch (error) {
      console.log(error);
    }
  }

  getParkingPlaceRegConfig() {
    this.coreService.GetParkingPlaceRegConfig().then((result) => {
      let countries = result.countries;
      let parking_charge_types = result.parking_charge_types;
      let currency_choices = result.currency_choices;
      //we got all the data as an object so converting that object to key value pairs.
      for (let key in countries) {
        if (countries.hasOwnProperty(key)) {
          let temp1 = { code: key, name: countries[key] };
          this.countries.push(temp1);
        }
      }
      for (let key in parking_charge_types) {
        if (parking_charge_types.hasOwnProperty(key)) {
          let temp2 = { key: key, value: parking_charge_types[key] };
          this.parking_charge_types.push(temp2);
        }
      }
      for (let key in currency_choices) {
        if (currency_choices.hasOwnProperty(key)) {
          let temp2 = { key: key, value: currency_choices[key] };
          this.currency_choices.push(temp2);
        }
      }
    });
  }

  setCurrentPosition() {
    this.center = {
      lat: 25.249062,
      lng: 55.2951105,
    };

    this.markerPosition = { ...this.center };
  }

  markerDragEndAddress(event: google.maps.MapMouseEvent) {
    if (!event.latLng) {
      return;
    }

    this.lat = event.latLng.lat();
    this.lng = event.latLng.lng();

    this.form.patchValue({
      lat: this.lat,
      lng: this.lng,
    });
  }

  onMapClick(event: google.maps.MapMouseEvent) {
    const lat = event.latLng?.lat();
    const lng = event.latLng?.lng();

    if (!lat || !lng) return;

    this.markerPosition = { lat, lng };

    this.form.patchValue({ lat, lng });
  }

  saveFormGroup(source: string) {
    switch (source) {
      case "stack": {
        const tempForm = <UntypedFormArray>this.form.controls.charge_stack;
        tempForm.push(this.stack);
        this.stack = this.createFormGroup("stack");
        break;
      }

      case "gate": {
        const tempForm = <UntypedFormArray>this.form.controls.parking_gates;
        tempForm.push(this.gate);
        this.gate = this.createFormGroup("gate");
        break;
      }

      case "autopay": {
        const tempForm = <UntypedFormArray>this.form.controls.autopay_machines;
        tempForm.push(this.autopay);
        this.autopay = this.createFormGroup("autopay");
        break;
      }

      case "camera_groups": {
        const tempForm = <UntypedFormArray>this.form.controls.camera_groups;
        tempForm.push(this.camera_groups);
        this.camera_groups = this.createFormGroup("camera_groups");
        break;
      }
      case "beneficiary": {
        const tempForm = <UntypedFormArray>(
          this.form.controls.parking_beneficiary
        );
        tempForm.push(this.beneficiary);
        this.beneficiary = this.createFormGroup("beneficiary");
        break;
      }
    }
  }

  deleteFormGroup(index: number, source: string) {
    if (confirm(`Are you sure you want to delete ${source}?`)) {
      switch (source) {
        case "stack": {
          const tempForm = <UntypedFormArray>this.form.controls.charge_stack;
          tempForm.removeAt(index);
          break;
        }

        case "gate": {
          const tempForm = <UntypedFormArray>this.form.controls.parking_gates;
          tempForm.removeAt(index);
          break;
        }

        case "autopay": {
          const tempForm = <UntypedFormArray>(
            this.form.controls.autopay_machines
          );
          tempForm.removeAt(index);
          break;
        }

        case "camera_groups": {
          const tempForm = <UntypedFormArray>this.form.controls.camera_groups;
          tempForm.removeAt(index);
          break;
        }
        case "beneficiary": {
          const tempForm = <UntypedFormArray>(
            this.form.controls.parking_beneficiary
          );
          tempForm.removeAt(index);
          break;
        }
      }
    }
  }

  viewFormGroup(index: number, source: string) {
    switch (source) {
      case "stack": {
        this.view_charge_stack = index;
        this.selected_rate = this.view_charge_stack.value.rate;
        this.selected_label_en = this.view_charge_stack.value.label_en;
        this.selected_label_ar = this.view_charge_stack.value.label_ar;
        this.selected_from_minutes = this.view_charge_stack.value.from_min;
        this.selected_to_minutes = this.view_charge_stack.value.to_min;
        break;
      }

      case "gate": {
        this.view_gate = index;
        this.selected_gate = this.view_gate.value.gate_no;
        this.selected_gate_status = this.view_gate.value.status;
        this.selected_gate_type = this.view_gate.value.gate_type;
        break;
      }
      case "camera_groups": {
        this.view_camera_groups = index;
        this.selected_camera_group_id =
          this.view_camera_groups.value.camera_group_id;
        this.selected_name = this.view_camera_groups.value.name;
        this.selected_parking_gates =
          this.view_camera_groups.value.parking_gates;
        this.selected_status = this.view_camera_groups.value.status;
        break;
      }
      case "beneficiary": {
        this.view_beneficiaries = index;
        this.selected_beneficiary = this.view_beneficiaries.value.beneficiary;
        this.selected_amount_type = this.view_beneficiaries.value.amount_type;
        this.selected_amount_calc = this.view_beneficiaries.value.amount_calc;
        this.selected_value = this.view_beneficiaries.value.value;
        break;
      }

      case "autopay": {
        this.view_autopay = index;
        this.selected_machine_id = this.view_autopay.value.machine_id;
        // this.selected_amount_type=this.view_beneficiaries.value.amount_type;
        // this.selected_amount_calc=this.view_beneficiaries.value.amount_calc;
        this.selected_autopay_status = this.view_autopay.value.machine_status;
        break;
      }
    }
  }

  editFormGroup(source: string) {
    switch (source) {
      case "stack": {
        const tempForm = <UntypedFormArray>(
          this.form.controls.charge_stack.value
        );
        var charge_stack = [];
        this.view_charge_stack.value["rate"] = this.selected_rate;
        this.view_charge_stack.value["label_en"] = this.selected_label_en;
        this.view_charge_stack.value["label_ar"] = this.selected_label_ar;
        this.view_charge_stack.value["from_min"] = this.selected_from_minutes;
        this.view_charge_stack.value["to_min"] = this.selected_to_minutes;
        for (var item = 0; item < tempForm.length; item++) {
          if (tempForm[item].id == this.view_charge_stack.value["id"]) {
            charge_stack.push(this.view_charge_stack.value);
          } else {
            charge_stack.push(tempForm[item]);
          }
        }

        this.form.controls.charge_stack.setValue(charge_stack);
        this.view_charge_stack = null;
        this.selected_rate = "";
        this.selected_label_en = "";
        this.selected_label_ar = "";
        this.selected_from_minutes = "";
        this.selected_to_minutes = "";
        break;
      }

      case "gate": {
        const tempForm = this.form.controls.parking_gates.value;
        var parking_gates = [];
        this.view_gate.value["gate_no"] = this.selected_gate;
        this.view_gate.value["gate_type"] = this.selected_gate_type;
        this.view_gate.value["status"] = this.selected_gate_status;
        for (var item = 0; item < tempForm.length; item++) {
          if (tempForm[item].id == this.view_gate.value["id"]) {
            parking_gates.push(this.view_gate.value);
          } else {
            parking_gates.push(tempForm[item]);
          }
        }

        this.form.controls.parking_gates.setValue(parking_gates);
        this.view_gate = null;
        this.selected_gate = "";
        this.selected_gate_type = "";
        this.selected_gate_status = "";
        break;
      }
      case "camera_groups": {
        const cameraForm = this.form.controls.camera_groups.value;
        var camera_groups = [];
        this.view_camera_groups.value["camera_group_id"] =
          this.selected_camera_group_id;
        this.view_camera_groups.value["name"] = this.selected_name;
        this.view_camera_groups.value["parking_gates"] =
          this.selected_parking_gates;
        this.view_camera_groups.value["status"] = this.selected_status;
        for (var item = 0; item < cameraForm.length; item++) {
          if (cameraForm[item].id == this.view_camera_groups.value["id"]) {
            camera_groups.push(this.view_camera_groups.value);
          } else {
            camera_groups.push(cameraForm[item]);
          }
        }

        this.form.controls.camera_groups.setValue(camera_groups);
        this.view_camera_groups = null;
        this.selected_camera_group_id = "";
        this.selected_name = "";
        this.selected_parking_gates = "";
        this.selected_status = "";
        break;
      }
      case "beneficiary": {
        const beneficiaryForm = this.form.controls.parking_beneficiary.value;
        var parking_beneficiary = [];
        this.view_beneficiaries.value["beneficiary"] =
          this.selected_beneficiary;
        this.view_beneficiaries.value["amount_type"] =
          this.selected_amount_type;
        this.view_beneficiaries.value["amount_calc"] =
          this.selected_amount_calc;
        this.view_beneficiaries.value["value"] = this.selected_value;
        for (var item = 0; item < beneficiaryForm.length; item++) {
          if (beneficiaryForm[item].id == this.view_beneficiaries.value["id"]) {
            parking_beneficiary.push(this.view_beneficiaries.value);
          } else {
            parking_beneficiary.push(beneficiaryForm[item]);
          }
        }

        this.form.controls.parking_beneficiary.setValue(parking_beneficiary);
        this.view_beneficiaries = null;
        this.selected_beneficiary = "";
        this.selected_amount_type = "";
        this.selected_amount_calc = "";
        this.selected_value = "";
        break;
      }
      case "autopay": {
        const autopayForm = this.form.controls.autopay_machines.value;
        var autopay_machines = [];
        this.view_autopay.value["machine_id"] = this.selected_machine_id;
        this.view_autopay.value["machine_status"] =
          this.selected_autopay_status;
        for (var item = 0; item < autopayForm.length; item++) {
          if (autopayForm[item].id == this.view_autopay.value["id"]) {
            autopay_machines.push(this.view_autopay.value);
          } else {
            autopay_machines.push(autopayForm[item]);
          }
        }

        this.form.controls.autopay_machines.setValue(autopay_machines);
        this.view_autopay = null;
        this.selected_machine_id = "";
        this.selected_autopay_status = "";
        break;
      }
    }
  }

  saveParkingPlace() {
    this.isSubmitted = true;
    console.log("Is form valid?", this.getFormValidationErrors());
    if (this.getFormValidationErrors()) {
      console.log("submitting");
      this.form.controls.lat.setValue(
        this.truncate(this.form.controls.lat.value, 6),
      );
      this.form.controls.lng.setValue(
        this.truncate(this.form.controls.lng.value, 6),
      );
      console.log(this.form.value);
      this.submit.emit(this.form.value);
    }
  }

  getFormValidationErrors() {
    let valid = true;
    Object.keys(this.form.controls).forEach((key) => {
      const controlErrors: ValidationErrors = this.form.get(key).errors;
      if (controlErrors != null) {
        valid = false;
        Object.keys(controlErrors).forEach((keyError) => {
          console.log(
            "Key control: " + key + ", keyError: " + keyError + ", err value: ",
            controlErrors[keyError],
          );
        });
      }
    });
    return valid;
  }

  truncate(num, places) {
    return Math.trunc(num * Math.pow(10, places)) / Math.pow(10, places);
  }

  getTitle(id) {
    return this.beneficiaries.find((element) => element.id == id).title;
  }

  onStepChange(index: number) {
    const previous = this.currentStep;
    this.currentStep = index;

    if (index === 0) {
      this.firstStepEnter();
    }

    if (index === 1) {
      this.secondStepEnter(previous < index);
    }

    if (index === 2) {
      this.thirdStepEnter(previous < index);
    }
  }
}
